import { Loadable } from '../../Loadable';

export const AsyncSharedDrinks = Loadable(() => import('./shared'));
export const AsyncAddDrink = Loadable(() => import('./Add'));
export const AsyncEditDrink = Loadable(() => import('./Edit'));
export const AsyncMergeDrinks = Loadable(() => import('./Merge'));
export const AsyncDrinkList = Loadable(() => import('./List'));
